// import React from "react";
// import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
// import logo from "../images/Helix logo.jpg";

// // Icons
// import webIcon from "../images/web.jpg";
// import phoneIcon from "../images/phone icon.jpg";
// import locationIcon from "../images/location icon.jpg";
// import messageIcon from "../images/message.jpg";

// // Clients image
// import clientsImage from "../images/OurClients.jpg"; // <-- Save your uploaded image as clients.png

// const BankDetailsPage = ({ bankDetails, legalCerts, preparedBy,regards }) => (
//   <Page size="A4" style={styles.page}>
//     {/* Header */}
//     <View style={styles.header}>
//       <Image src={logo} style={styles.logo} />
//       <View style={styles.headerRight}>
//         <Image src={webIcon} style={styles.iconSmall} />
//         <Text style={styles.website}>{preparedBy.website}</Text>
//       </View>
//     </View>

//     {/* Body */}
//     <View style={styles.body}>
//       {/* Bank Details */}
//       <View style={styles.table}>
//         <View style={styles.row}>
//           <Text style={styles.label}>Legal Name</Text>
//           <Text style={styles.value}>{bankDetails.legalName}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>Bank Name</Text>
//           <Text style={styles.value}>{bankDetails.bankName}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>Account No</Text>
//           <Text style={styles.value}>{bankDetails.accountNo}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>IFSC Code</Text>
//           <Text style={styles.value}>{bankDetails.ifsc}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>Branch</Text>
//           <Text style={styles.value}>{bankDetails.branch}</Text>
//         </View>
//       </View>

//       {/* Legal Certificates */}
//       <View style={[styles.table, { marginTop: 15 }]}>
//         <View style={styles.row}>
//           <Text style={styles.label}>GSTIN No:</Text>
//           <Text style={styles.value}>{legalCerts.gstin}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>PAN No:</Text>
//           <Text style={styles.value}>{legalCerts.pan}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>IEC:</Text>
//           <Text style={styles.value}>{legalCerts.iec}</Text>
//         </View>
//         <View style={styles.row}>
//           <Text style={styles.label}>ISO CER:</Text>
//           <Text style={styles.value}>{legalCerts.iso}</Text>
//         </View>
//       </View>

//       {/* Regards */}
//       <View style={{ marginTop: 20 }}>
//         <Text>Regards</Text>
//         <Text>{regards.name}</Text>
//         <Text>Con:{regards.contact}</Text>
//         <Text style={{ color: "blue" }}>{preparedBy.emails[1]}</Text>
//       </View>

//       {/* Clients Section */}
//       <View style={styles.clientsSection}>
//         <Image src={clientsImage} style={styles.clientsImage} />
//       </View>
//     </View>

//     {/* Footer */}
//     <View style={styles.footer}>
//       {/* Phone */}
//       <View style={styles.footerSection}>
//         <Image src={phoneIcon} style={styles.icon} />
//         <View>
//           {preparedBy.phones.map((ph, i) => (
//             <Text key={i} style={styles.footerText}>{ph}</Text>
//           ))}
//         </View>
//       </View>

//       {/* Location */}
//       <View style={[styles.footerSection, styles.footerCenter]}>
//         <Image src={locationIcon} style={styles.icon} />
//         <Text style={styles.footerText}>{preparedBy.address}</Text>
//       </View>

//       {/* Email */}
//       <View style={[styles.footerSection, styles.footerRight]}>
//         <Image src={messageIcon} style={styles.icon} />
//         <View>
//           {preparedBy.emails.map((em, i) => (
//             <Text key={i} style={styles.footerText}>{em}</Text>
//           ))}
//         </View>
//       </View>
//     </View>
//   </Page>
// );

// const styles = StyleSheet.create({
//   page: {
//     padding: 25,
//     fontSize: 10,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff",
//     flexDirection: "column",
//     justifyContent: "space-between",
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottom: "2pt solid #b20000",
//     paddingBottom: 6,
//     marginBottom: 15,
//   },
//   logo: {
//     width: 80,
//     height: 80,
//   },
//   headerRight: {
//     flexDirection: "row",
//     alignItems: "center",
//   },
//   website: {
//     fontSize: 11,
//     color: "#b20000",
//     fontWeight: "bold",
//     marginLeft: 5,
//   },
//   body: {
//     flexGrow: 1,
//     paddingHorizontal: 20,
//   },
//   table: {
//     border: "1pt solid #000",
//   },
//   row: {
//     flexDirection: "row",
//     borderBottom: "1pt solid #000",
//     padding: 5,
//   },
//   label: {
//     width: "40%",
//     fontWeight: "bold",
//   },
//   value: {
//     width: "60%",
//   },
//   clientsSection: {
//     marginTop: 25,
//     textAlign: "center",
//   },
//   clientsTitle: {
//     fontSize: 12,
//     fontWeight: "bold",
//     marginBottom: 10,
//   },
//   clientsImage: {
//     width: "100%",
//     height: 250, // adjust if image looks stretched
//     objectFit: "contain",
//   },
//   footer: {
//     flexDirection: "row",
//     backgroundColor: "#b20000",
//     color: "#fff",
//     padding: 8,
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   footerSection: {
//     flexDirection: "row",
//     alignItems: "center",
//     width: "30%",
//   },
//   footerCenter: {
//     width: "40%",
//     textAlign: "center",
//   },
//   footerRight: {
//     justifyContent: "flex-end",
//     textAlign: "right",
//   },
//   footerText: {
//     fontSize: 9,
//     marginLeft: 4,
//     color: "#fff",
//   },
//   icon: {
//     width: 30,
//     height: 30,
//     marginRight: 4,
//   },
//   iconSmall: {
//     width: 30,
//     height: 30,
//     marginRight: 3,
//   },
// });

// export default BankDetailsPage;


import React from "react";
import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../../images/Final-logo-SBS.png"

// Icons
import webIcon from "../images/web.jpg";
import phoneIcon from "../images/phone icon.jpg";
import locationIcon from "../images/location icon.jpg";
import messageIcon from "../images/message.jpg";

// Clients image
import clientsImage from "../images/OurClients.jpg"; // <-- Save your uploaded image as clients.png

const BankDetailsPage = ({companyInfo , regardsInfo}) => (
  <Page size="A4" style={styles.page}>
    {/* Header */}
    <View style={styles.header}>
      <Image src={logo} style={styles.logo} />
      <View style={styles.headerRight}>
        <Image src={webIcon} style={styles.iconSmall} />
        <Text style={styles.website}>sbsgroups.co.in</Text>
      </View>
    </View>

    {/* Body */}
    <View style={styles.body}>
      {/* Bank Details */}
      <View style={styles.table}>
        <View style={styles.row}>
          <Text style={styles.label}>Legal Name</Text>
          <Text style={styles.value}>{companyInfo.legalName}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Bank Name</Text>
          <Text style={styles.value}>{companyInfo.bankName}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Account No</Text>
          <Text style={styles.value}>{companyInfo.accountNo}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>IFSC Code</Text>
          <Text style={styles.value}>{companyInfo.ifscCode}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Branch</Text>
          <Text style={styles.value}>{companyInfo.branch}</Text>
        </View>
      </View>

      {/* Legal Certificates */}
      <View style={[styles.table, { marginTop: 15 }]}>
        <View style={styles.row}>
          <Text style={styles.label}>GSTIN No:</Text>
          <Text style={styles.value}>{companyInfo.gstin}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>PAN No:</Text>
          <Text style={styles.value}>{companyInfo.pan}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>IEC:</Text>
          <Text style={styles.value}>{companyInfo.iec}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>ISO CER:</Text>
          <Text style={styles.value}>{companyInfo.isoCer}</Text>
        </View>
      </View>

      {/* Regards */}
      <View style={{ marginTop: 20 }}>
        <Text>Regards</Text>
        <Text>{regardsInfo.name}</Text>
        <Text>Con: {regardsInfo.mobile}</Text>
        <Text style={{ color: "blue" }}>{regardsInfo.email}</Text>
      </View>

      {/* Clients Section */}
      <View style={styles.clientsSection}>
        {/* <Text style={styles.clientsTitle}>FEW OF OUR VALUABLE CLIENTS</Text> */}
        <Image src={clientsImage} style={styles.clientsImage} />
      </View>
    </View>

    {/* Footer */}
    <View style={styles.footer}>
      {/* Phone */}
      <View style={styles.footerSection}>
        <Image src={phoneIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>8827559628</Text>
          <Text style={styles.footerText}>9826808412</Text>
        </View>
      </View>

      {/* Location */}
      <View style={[styles.footerSection, styles.footerCenter]}>
        <Image src={locationIcon} style={styles.icon} />
        <Text style={styles.footerText}>
          Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
        </Text>
      </View>

      {/* Email */}
      <View style={[styles.footerSection, styles.footerRight]}>
        <Image src={messageIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
          <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
        </View>
      </View>
    </View>
  </Page>
);

const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2pt solid #b20000",
    paddingBottom: 6,
    marginBottom: 15,
  },
  logo: {
    width: 80,
    height: 80,
  },
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
  },
  website: {
    fontSize: 11,
    color: "#b20000",
    fontWeight: "bold",
    marginLeft: 5,
  },
  body: {
    flexGrow: 1,
    paddingHorizontal: 20,
  },
  table: {
    border: "1pt solid #000",
  },
  row: {
    flexDirection: "row",
    borderBottom: "1pt solid #000",
    padding: 5,
  },
  label: {
    width: "40%",
    fontWeight: "bold",
  },
  value: {
    width: "60%",
  },
  clientsSection: {
    marginTop: 25,
    textAlign: "center",
  },
  clientsTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10,
  },
  clientsImage: {
    width: "100%",
    height: 250, // adjust if image looks stretched
    objectFit: "contain",
  },
  footer: {
    flexDirection: "row",
    backgroundColor: "#b20000",
    color: "#fff",
    padding: 8,
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerSection: {
    flexDirection: "row",
    alignItems: "center",
    width: "30%",
  },
  footerCenter: {
    width: "40%",
    textAlign: "center",
  },
  footerRight: {
    justifyContent: "flex-end",
    textAlign: "right",
  },
  footerText: {
    fontSize: 9,
    marginLeft: 4,
    color: "#fff",
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 4,
  },
  iconSmall: {
    width: 30,
    height: 30,
    marginRight: 3,
  },
});

export default BankDetailsPage;

